export default function HeroContainer({ children }) {
  return <div className="hero-container">{children}</div>;
}
